(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/browse/browse.tpl.html', [
'<!--',
'',
' * Copyright (C) 2009-2026 by the geOrchestra PSC',
' *',
' * This file is part of geOrchestra.',
' *',
' * geOrchestra is free software: you can redistribute it and/or modify it under',
' * the terms of the GNU General Public License as published by the Free',
' * Software Foundation, either version 3 of the License, or (at your option)',
' * any later version.',
' *',
' * geOrchestra is distributed in the hope that it will be useful, but WITHOUT',
' * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or',
' * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for',
' * more details.',
' *',
' * You should have received a copy of the GNU General Public License along with',
' * geOrchestra.  If not, see <http://www.gnu.org/licenses/>.',
' ',
'-->',
'',
'<div class="alert alert-info">',
'  <a ng-link="users({id: \'all\'})" class="category" ng-class="{active: !roles.activeRole}" translate>role.allusers</a>',
'  <div ng-repeat="role in roles.adminList | filter: roles.protected">',
'    <a ng-link="users({id: role.cn})" class="category" ng-class="{active: roles.activeRole.cn === role.cn}">',
'      <span>{{\'users.\'+role.cn | translate}}</span>',
'      ({{::role.users.length}})',
'    </a>',
'  </div>',
'  <a ng-link="users({id: \'pending\'})" class="category" ng-class="{active: roles.activeRole.cn === \'PENDING\'}">',
'    <span translate>users.PENDING</span>',
'    ({{roles.pendingCount}})',
'  </a>',
'  <hr>',
'  <div class="create-btn">',
'    <a ng-link="newUser" class="btn btn-default" translate>role.newuser</a>',
'  </div>',
'</div>',
'',
'<input ng-model="roles.q" class="form-control input-sm" placeholder="{{\'role.search\' | translate}}">',
'',
'<h5 ng-if="roles.q == \'\'" translate>role.system</h5>',
'<div ng-repeat="role in roles.adminList | filter: roles.unprotected" ng-if="roles.q == \'\'">',
'  <strong ng-if="(roles.activeRole.cn == role.cn)">',
'    {{::role.cn}} ({{::role.users.length}})',
'  </strong>',
'  <a ng-link="users({id: role.cn})" ng-if="(roles.activeRole.cn != role.cn)" title={{::role.description}}>',
'    {{::role.cn}}',
'   ({{::role.users.length}})',
' </a>',
'</div>',
'',
'<h5 ng-if="roles.q == \'\'" translate>role.favorites</h5>',
'<div ng-repeat="role in roles.roles.filter(roles.favoriteRole)" ng-if="roles.q == \'\'" title={{::role.description}}>',
'  <strong ng-if="(roles.activeRole.cn == role.cn)">',
'    {{::role.cn}} ({{::role.users.length}})',
'  </strong>',
'  <a ng-link="users({id: role.cn})" ng-if="(roles.activeRole.cn != role.cn)">',
'    {{::role.cn}}',
'   ({{::role.users.length}})',
' </a>',
'</div>',
'',
'<div ng-repeat="(key, role) in roles.index" ng-if="roles.q != \'\'">',
'  <a ng-link="users({id: role.cn})" title={{::role.description}}',
'      ng-if="role.cn.toLowerCase().indexOf(roles.q.toLowerCase()) >= 0">',
'    {{::role.cn}} ({{::role.users.length}})',
'  </a>',
'</div>',
'',''].join("\n"));
  }]);
})();